import { ElementState } from "@creatomate/preview";
import { ElementSource } from "chq";
import isSubtitleText from "./isSubtitleText";

const updateSubtitleSectionTimeById = (
  elements: ElementSource[],
  activeElementsId: string[],
  currentElement: ElementState,
  newTime: number,
  newDuration: number
): ElementSource[] => {
  const elementsNames = elements.filter((element: ElementSource) => (
    activeElementsId.includes(element.id))
  ).map((element: ElementSource) => element.name);

  // Create a map of prefix-index pairs from elementsNames
  const targetPairs = elementsNames.map(name => {
    const [prefix, index] = name.split("-", 2);
    return { prefix, index };
  });

  const updatedElements = elements.map((element: ElementSource) => {
    if (element.id === currentElement.source.id) {
      return {
        ...element,
        time: newTime,
        duration: newDuration
      };
    }

    if (isSubtitleText(element.name)) {
      const [otherPrefix, otherIndex] = element.name.split("-", 2);
      const matchingPair = targetPairs.find(pair => (
        pair.prefix === otherPrefix && pair.index === otherIndex
      ));

      const timeOffset = newTime - currentElement.globalTime;
      const durationOffset = newDuration - currentElement.duration;

      if (activeElementsId.includes(element.id)) {
        return {
          ...element,
          time: element.time,
          duration: element.duration
        };
      }

      if (matchingPair) {
        return {
          ...element,
          time: element.time + timeOffset,
          duration: element.duration + durationOffset
        };
      }
    }

    return element;
  });

  return updatedElements;
};

export default updateSubtitleSectionTimeById;
